export const projects = [
  {
    name: "Acacia Health Insurance",
    sub: "React Native | Vue.js",
    img: "/img/acacia.jpg",
    description:
      "Acacia Health Insurance (Acacia) is a Private Commercial Health Insurance Company registered under the laws of Ghana which operates for the benefit of its members.",
    info: [
      {
        name: "Acacia Mobile",
        about:
          "The Acacia 2021 mobile application is a cross platform app built using react native. Clients are able to view regular healh tips, get water intake reminders, monitor medications directly from the hospital, log complains in a chat forum or chat directly with Dr. Cacia.",
        img: "/img/acacia/1.webp",
        type: 3,
        imgs: [
          "/img/acacia/1.webp",
          "/img/acacia/2.webp",
          "/img/acacia/3.webp",
        ],
        link_tag: "Download Android Version",
        link:
          "https://play.google.com/store/apps/details?id=com.acacia.acaciahealthinsurance",
      },
      {
        name: "Development & Deployment",
        about:
          "This application was deployed succesfully on google play store and iOS app store",
        img: "/img/acacia/main.jpeg",
        type: 1,
        link_tag: "Download iOS Version",
        link:
          "https://apps.apple.com/gh/app/acacia-health-insurance/id1535233495",
      },
    ],
  },
  {
    name: "Duotone Maker",
    sub: "Vuejs - Nuxtjs",
    img: "/img/duotone/1.png",
    description:
      "Duotone is a free online tool used to duotone images with two colors",
    info: [
      {
        name: "Homepage",
        about:
          "Users can access images directly from unsplash and pexels and duotone the images and download them. They can also upload their own images and apply the duotone effect on them",
        img: "/img/duotone/1.png",
        type: 0,
        link_tag: "Visit Duotonemaker - Website",
        link: "https://duotonemaker.netlify.app",
      },
      {
        name: "Mobile View",
        about: "Duotone can seamlessly be used on mobile devices as well",
        img: "/img/duotone/2.png",
        type: 1,
        link_tag: "Visit Duotonemaker - Website",
        link: "https://duotonemaker.netlify.app",
      },
    ],
  },
  {
    name: "Pappermap",
    sub: "Nextjs | FastAPI",
    description:
      "Transform your analytics to everyday conversations. With prompt engineering integrated into our analytics capability, you can connect to any database to boost your business intelligence and operations.",
    img: "/img/pappermap/1.png",
    info: [
      {
        name: "Pappermap",
        about:
          "Compare current product performance with past performance, allowing users to identify shifts over time.",
        img: "/img/pappermap/1.png",
        type: 0,
        link_tag: "Visit Pappermap - Website",
        link: "https://www.pappermap.com/",
      },
      {
        name: "Pappermap Website",
        about:
          "Support integration with other software for data import/export, such as POS systems or ERPs.",
        img: "/img/pappermap/2.png",
        type: 1,
        link_tag: "Visit Pappermap - Website",
        link: "https://www.pappermap.com/",
      },
      {
        name: "Pappermap Charts",
        about: "Custom Graphs and Charts Request specific visualization to analyze data, trends, or performances.",

        type: 0,
        img: "/img/pappermap/4.png",

        link_tag: "Visit Pappermap - Website",
        link: "https://www.pappermap.com/",
      },
      {
        name: "Pappermap Dashboard",
        about: "Customizable Data Tables Request tables with specific columns or data points filtered by various criteria.",

        type: 1,
        img: "/img/pappermap/6.png",

        link_tag: "Visit Pappermap - Website",
        link: "https://www.pappermap.com/",
      },
    ],
  },
  {
    name: "Regulus Finance",
    sub: "Larvel| Vue.js",
    img: "/img/regulus/1.png",
    description:
      "Regulus Financial Services aims to be the largest neutraI market place of financial products in Africa providing unmatched efficiencies and effectiveness of entire the Financial ecosystem for individuals institutions & the Ghanaian economy at large.",
    info: [
      {
        name: "Development & Deployment",
        about: "",
        img: "/img/regulus/calculator.png",
        type: 1,
        link_tag: "Visit Regulus Finance - Website",
        link: "https://regulus.finance",
      },
    ],
  },
  {
    name: "FireDNS WebApp",
    sub: "Vue.js",
    img: "/img/firedns/1.png",
    description:
      "A free, global DNS resolution service that protects users by blocking malicious domains and websites.",
    info: [
      {
        name: "Development & Deployment",
        about: "",
        img: "/img/firedns/2.png",
        type: 1,
        link_tag: "Visit FireDNS Finance - Website",
        link: "https://dashboard.firedns.io/signup",
      },
    ],
  },
  {
    name: "Symliq",
    sub: "Laravel",
    description:
      "A software developing company with a diverse team of developers and designers that provides a range of services including mobile app development, enterprise application development and graphic design with our large arsenal of programming languages supported by creative UI & UX skills.",
    img: "/img/symliq.png",
    info: [
      {
        name: "Symliq Website",
        about:
          "Check out the symliq website I created and deployed with Laravel",
        img: "/img/symliq.png",
        type: 0,
        link_tag: "Visit Symliq - Website",
        link: "https://symliq.com",
      },
    ],
  },
  {
    name: "Zivot Consult",
    sub: "Laravel",
    description:
      "A consultancy firm dedicated to assisting individuals with career development, study abroad and migration needs",
    img: "/img/zivotconsult/home.gif",
    info: [
      {
        name: "Zivotconsult Website",
        about:
          "This website was developed with html,css, js, tailwind and Laravel",
        img: "/img/zivotconsult/home.gif",
        type: 1,
        link_tag: "Visit Zivot - Website",
        link: "https://zivotconsult.org",
      },
      {
        name: "Zivotconsult Website",
        about:
          "Check out the zivotconsult website, created and deployed on Digital Ocean",
        img: "/img/zivotconsult/services.png",
        type: 0,
        link_tag: "Visit Zivot - Website",
        link: "https://zivotconsult.org",
      },
    ],
  },

  /*   {
           name: "Open Source",
           sub: "Laravel",
           description: "An excellent immigration firm",
           img: "/img/zivotconsult/home.gif",
           info: [
             {
               name: "Zivotconsult Website",
               about:
                 "This website was developed with html,css, js, tailwind and Laravel",
               img: "/img/zivotconsult/home.gif",
               type: 1,
               link_tag: "Visit Zivot - Website",
               link: "https://zivotconsult.com",
             },
             {
               name: "Zivotconsult Website",
               about:
                 "Check out the zivotconsult website, created and deployed on Digital Ocean",
               img: "/img/zivotconsult/services.png",
               type: 0,
               link_tag: "Visit Zivot - Website",
               link: "https://zivotconsult.com",
             },
           ],
         }, */
  {
    name: "Aljani",
    sub: "Vue.js | Laravel",
    img: "/img/aljani.jpg",
    description:
      "ALJANI is an online platform that sells quality Made-In-Ghana products. We are motivated by our core purpose to create the biggest rise in the consumption of African manufactured products.",
    info: [
      {
        name: "Aljani Website",
        about:
          "The aljani website currently houses the coming soon of the android and ios aljani ecommerce app",
        img: "/img/aljani/home.png",
        type: 0,
        link_tag: "Visit Aljani - Website",
        link: "https://aljani.com",
      },
      {
        name: "Supplier's Portal",
        about:
          "This portal was built for the suppliers of aljani. With this, suppliers are able to manage inventory, track their orders, view analytics on their income from aljani and generate monthly reports of their activities. Built aljani supplier's portal using html, css, javascript and vue.js",
        img: "/img/aljani/suppliers.png",
        type: 1,
        link: "",
      },
    ],
  },

  {
    name: "Pipescore",
    sub: "Django | Vue.js ",
    description:
      "Pipescore-api, takes a keyword and searches through, facebook, google news and instagram for posts, news and groups and performs a sentimental analysis on the post (text) using textBlob to give the sentiment(polarity, subjectivity) thus to show how positive or negative the post is",
    img: "/img/pipescore.jpg",
    info: [
      {
        name: "Pipescore-api",
        about: "Built using the django framework (python) and mysql. ",
        img: "/img/pipescore/1.png",
        type: 0,
        link_tag: "Open Source on Github",
        link: "https://github.com/Leleking/pipescore-django_api",
      },
      {
        name: "Pipescore App",
        about: "Pipescore vue frontend to a sentimental analysis api",
        img: "/img/pipescore/1.png",
        type: 2,
        link_tag: "Open Source on Github",
        link: "https://github.com/Leleking/pipescore-frontend",
      },
    ],
  },
];
